// Import translation
import i18n from 'i18next';

// Import helpers
import { checkPinFormat } from 'helpers';

export default ({ pin }) => {
	const errors = {};

	const isPinValid = checkPinFormat(pin);

	// ------------------ PIN ------------------
	if (!pin) {
		errors.pin = i18n.t(`user_profile_recordings_pin_required`);
	} else if (!isPinValid) {
		errors.pin = i18n.t(`user_profile_recordings_pin_format`);
	}

	return errors;
};
